import { render } from "./investors-panel.vue?vue&type=template&id=2ef944b4&scoped=true&ts=true"
import script from "./investors-panel.vue?vue&type=script&lang=ts"
export * from "./investors-panel.vue?vue&type=script&lang=ts"

import "./investors-panel.vue?vue&type=style&index=0&id=2ef944b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef944b4"]])

export default __exports__